import { render, staticRenderFns } from "./enterprise-table-text.vue?vue&type=template&id=797d9968&scoped=true"
import script from "./enterprise-table-text.vue?vue&type=script&lang=js"
export * from "./enterprise-table-text.vue?vue&type=script&lang=js"
import style0 from "./enterprise-table-text.vue?vue&type=style&index=0&id=797d9968&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797d9968",
  null
  
)

export default component.exports